module.exports = __webpack_public_path__ + "static/image/company/pc/image_resolutions@3x.jpg?9ecb807b";